module.exports = __webpack_public_path__ + "img/suc.e6420c1e.svg";